var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmyCommendation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_48)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "#245C28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    width: 20,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375,
    width: 20,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435,
    width: 20,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    width: 20,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    width: 20,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    width: 40,
    height: 250,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmyCommendation);
export default __webpack_public_path__ + "static/media/Army Commendation.d0c8457e1db618a0be47e37c83a4fde4.svg";
export { ForwardRef as ReactComponent };